/**
 * The kind filter's "Deleted" option. It isn't an `EntryKind` - picking it
 * clears the kind filter and sets `onlyMarkedForDeletion` instead.
 */
export const DELETED_KIND_FILTER_VALUE = "DELETED";
